import React from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";

const ShiftCards = ({ shiftData }) => {
  if (!shiftData) return null;

  return (
    <Row className="mb-4">
      {Object.entries(shiftData).map(([shiftName, values]) => (
        <Col md="4" key={shiftName}>
          <Card
            className="text-center shadow border border-secondary"
            style={{ backgroundColor: "rgb(37, 43, 59);", color: "#252231" }}
          >
            <CardBody>
              <CardTitle tag="h5" className="mb-3">
                {shiftName}
              </CardTitle>

              <h6 style={{ color: "#6ee7b7" }}>
                Good: {values.good}
              </h6>
              <h6 style={{ color: "#f87171" }}>
                Bad: {values.bad}
              </h6>
              <h5 className="mt-2">
                Total: {values.total}
              </h5>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ShiftCards;
